import { Alert, Autocomplete, Box, Button, Card, Container, Icon, Link, Select, TextField, Typography } from "@mui/material";
import { ArrowBack, ArrowForward, ArrowLeft, Warning } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helper } from "../services/Helper";
import { WebStorageService } from "../services/WebStorageService";
import { Order } from "../models/Order";

export default function OrderNowStep2() {
    const [fullName, setFullName] = useState('');
    const [mobilePhoneNumber, setPhoneNumber] = useState('');
    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const navigate = useNavigate();
    const [address, setAddress] = useState('');

    const ORDER_NOW = "ORDER_NOW";
    const webStorageService = new WebStorageService();
    let order: Order = webStorageService.getJson(ORDER_NOW);

    useEffect(() => {
        if (order != null) {
            if (Helper.HasValue(order.FirstName) && Helper.HasValue(order.LastName))
                setFullName(order.FirstName + ' ' + order.LastName);
            else if (Helper.HasValue(order.FirstName))
                setFullName(order.FirstName);
            else if (Helper.HasValue(order.LastName))
                setFullName(order.LastName);
            setPhoneNumber(order.MobilePhoneNumber);
            setAddress(order.Address);
        }
    }, []);

    function onNext() {
        let firstSpaceIndex = fullName.indexOf(" ");
        let firstName = fullName.substring(0, firstSpaceIndex);
        let lastName = fullName.substring(firstSpaceIndex + 1, fullName.length);

        if (!Helper.HasValue(firstName) || !Helper.HasValue(lastName)) {
            setHasError(true);
            setMessage("Please specify both First Name and Last Name.")
        } else if (!Helper.HasValue(mobilePhoneNumber)) {
            setHasError(true);
            setMessage("Mobile Phone Number is required.")
        } else if (mobilePhoneNumber.length != 11) {
            setHasError(true);
            setMessage("Mobile Phone Number must consists of 11 digits")
        } else if (mobilePhoneNumber.substring(0, 2) != "09") {
            setHasError(true);
            setMessage("Mobile Phone Number must starts with '09'")
        } else if (!Helper.HasValue(address)) {
            setHasError(true);
            setMessage("Address is required.")
        } else {
            setHasError(false);
            webStorageService.setJson(ORDER_NOW, { ...order, FirstName: firstName, LastName: lastName, MobilePhoneNumber: mobilePhoneNumber, Address: address });
            navigate("/order-now-step3")
        }
    }

    function onFullNameChanged(event: any) {
        setFullName(event.target.value);
    }

    return (
        <Container>
            <Card sx={{ marginTop: { xs: 8, sm: 15 }, padding: 2, background: "#FEF9F8", marginX: "auto", maxWidth: 400, boxShadow: { xs: 'none', md: 'var(--Paper-shadow)' } }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 4 }}>
                    <strong>Step 2:</strong> Ilagay ang pangalan ng taong hahanapin at phone number nya na pwede tawagan sakali mahirapan ang delivery man sa pag-hanap.
                </Typography>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="First Name and Last Name" type="text" placeholder="Pangalan ng dedeliveran" variant="outlined" fullWidth={true} value={fullName} onChange={(event: any) => onFullNameChanged(event)} slotProps={{ htmlInput: { maxLength: 100 } }}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="Mobile Phone Number (11 digits)" type="tel" placeholder="Example: 09192222881" variant="outlined" fullWidth={true} value={mobilePhoneNumber} onChange={(event: any) => setPhoneNumber(event.target.value)} slotProps={{ htmlInput: { maxLength: 11 } }} sx={{ letterSpacing: 10 }}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField onChange={(event: any) => setAddress(event.target.value)} multiline rows={2} label="Complete Address" placeholder="Number ng bahay, kalye, baranggay, city o munisipalidad." variant="outlined" fullWidth={true} value={address} slotProps={{ htmlInput: { maxLength: 250 } }}></TextField>
                </Box>
                {hasError && <Alert icon={<Warning></Warning>} severity="warning" sx={{ marginBottom: 4 }}>{message}</Alert>}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Link onClick={(e) => { e.preventDefault(); navigate("/order-now-step1"); }} variant="body2" sx={{ display: "flex", alignItems: "center", textDecoration: "none", marginY: 4, cursor: "pointer" }}><ArrowBack></ArrowBack> GO BACK</Link>
                    <Button variant="contained" sx={{ background: "#d32f2f", display: "flex", alignItems: "center" }} onClick={onNext}>NEXT <ArrowForward></ArrowForward></Button>
                </Box>
            </Card>
        </Container>
    );
}